<template>
	<div>
		<vs-card>
			<b-col lg="12" sm="12">
				<b-row>
					<b-col v-if="ROLE != 'Company'" lg="6" sm="12">
						<b-row class="mb-2">
							<b-col cols="3" align-self="center">
								<b-form-group :label="'* ' + $t('Customer')" class="vs-input--label pr-0 mr-0" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="CompanyName"
									v-on:input="
										clearSelected();
									getCustomerMarketplaces();
									" autocomplete ref="selectElement">
								</v-select>
							</b-col>
						</b-row>
					</b-col>
					<b-col lg="6" sm="12">
						<b-row class="mb-2">
							<b-col cols="3" align-self="center">
								<b-form-group :label="'* ' + $t('Marketplace')" class="vs-input--label pr-0 mr-0"
									label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select v-model="marketplace" label="Name" :options="marketplace_choices" size="small" autocomplete
									@input="sendMessageToIframe()" ref="selectElement">
									<template slot="option" slot-scope="option">
										<b-row>
											<b-col cols="2">
												<img v-if="mpControl(option.Name)" :src="require('../../assets/images/logo/' +
													option.Name.trim() +
													'.png')
													" width="30" v-b-tooltip.hover.bottom="option.Name" @error="errorImage" />
											</b-col>
											<b-col>
												{{ option.Prefix }} -
												{{ option.Name }}
											</b-col>
										</b-row>
									</template>
								</v-select>
							</b-col>
						</b-row>
					</b-col>

				</b-row>
			</b-col>
		</vs-card>
		<div style="width: 100%; height: 100vh; box-sizing: border-box;">
			<iframe id="myIframe" ref="myIframe" :src="iframeSrc" style="width: 100%; height: 100%; border: none;">
			</iframe>
		</div>
	</div>
</template>
<script>
import { uuid } from "vue-uuid";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import moment from "moment";
import { isMobile } from "mobile-device-detect";
import StockAddNew from "./StockAddNew.vue";
import SuccessBtn from "../../components/vx-button/SuccessBtn.vue";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue";
import i18nData from "../../i18n/i18nData";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import vSelect from "vue-select";
import userJson from "../../../public/user.json";
import AddStockWithExcel from "./AddStockWithExcel.vue";
import BundleProduct from "./BundleProduct.vue";
import BarcodePrintingTamplate from "../components/global-components/BarcodePrintingTamplate.vue";
export default {
	data() {
		return {
			iframeSrc: userJson.iframeUrl,
			storehouseForFilter: "",
			isSidebarActiveBarcodePrintTemp: false,
			rowClassRules: null,
			gridApi: null,
			customer: "",
			bulkStockPopup: false,
			ROLE: this.$store.state.AppActiveUser.ROLE,
			paginationPageSize: null,
			paginationPageSizeSelector: null,
			wholeStockActions: false,
			stockListFiltered: [],
			allBarcodesData: [],
			barcodeData: [],
			isBarcodeAddActive: false,
			deleteData: [{}],
			deleteWarningPromptValid: false,
			stockList: [],
			stockColumns: [],
			marketplace_choices: [],
			storehouse_choices: [],
			customer_choices: [],
			storehouseForCustomerList: [],
			storehouse: "",
			marketplace: "",
			searchedVal: "",
			addNewDataSidebar: false,
			addWithExcelPopup: false,

			sidebarData: {},
			sidebarAct: {},
			isMobile: function () {
				return isMobile;
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
			},
			filteredData: [],
			matchingItems: [],
			iframe: null
		};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
		company: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		//get stock list from store
		stock: {
			get() {
				return this.$store.state.stock.Stock;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
	},
	components: {
		BarcodePrintingTamplate,
		BundleProduct,
		AddStockWithExcel,
		vSelect,
		TextViewCellRenderer,
		uuid,
		statusShowCellRenderer,
		DeleteWarning,
		updateDeleteBtnCellRenderer,
		AgGridVue,
		StockAddNew,
		Icon,
		SuccessBtn,
	},

	methods: {
		clearSelected() {
			this.marketplace = "";
		},
		mpControl(e) {
			if (
				!e.includes("Toplu") &&
				!e.includes("Flip") &&
				!e.includes("Php") &&
				!e.includes("Tümü")
			)
				return true;
			else return false;
		},
		printBarcode(val = false) {
			this.isSidebarActiveBarcodePrintTemp = val;
		},
		printBarcodeControl() {
			var vs = this.$vs;
			this.printAcceptedValues = [];
			var selectedRows = this.gridApi.getSelectedRows();
			this.filteredData = selectedRows;
			if (this.filteredData.length > 0 && this.filteredData.length < 100) {
				console.log(this.filteredData);
				this.$store
					.dispatch("stock/listStockWithBarcodes", this.filteredData[0].CompanyId)
					.then((response) => {
						if (response.success == true) {
							console.log(JSON.parse(response.json));
							this.matchingItems = JSON.parse(response.json)
								.filter((item1) =>
									this.filteredData.some((item2) => item2.Stockno === item1.Stock.Stockno)
								)
								.map((item1) => item1.Stock);

							console.log(this.matchingItems);
							if (this.filteredData.length > 0 && this.filteredData.length < 100)
								this.printBarcode(true);
							else {
								const vs = this.$vs;

								vs.notify({
									text: this.$t("ValidateForTemplatePrint"),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "warning",
									position: "top-center",
								});
							}
							setTimeout(() => {
								vs.loading.close("#loading-item > .con-vs-loading");
							}, 1000);
							try {
							} catch (error) { }
						} else {
							setTimeout(() => {
								vs.loading.close("#loading-item > .con-vs-loading");
							}, 1000);
						}
					})
					.catch((error) => {
						console.log(error);
						setTimeout(() => {
							vs.loading.close("#loading-item > .con-vs-loading");
						}, 1000);
					});
			} else {
				const vs = this.$vs;

				vs.notify({
					text: this.$t("ValidateForTemplatePrint"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			}
		},
		addBundleProduct() {
			this.$router
				.push({
					name: "bundle-stock",
				})
				.catch(() => { });
		},
		onCellKeyDown(event) {
			if (event.event.key === "Enter") {
				const nextRowIndex = event.rowIndex + 1;
				const colKey = event.column.getId();
				if (nextRowIndex <= event.api.getDisplayedRowCount()) {
					this.onCellValueChanged(event);
				} else {
					event.api.stopEditing();
				}
			}
		},

		//for update QuantityMin
		onCellValueChanged(event) {
			var vs = this.$vs;
			let type = "material";
			vs.loading({
				container: `#loading-stock-list`,
				type,
				scale: 0.5,
			});
			const updatedProduct = event.data;

			const obj = {
				stockId: updatedProduct.StockId,
				stockno: updatedProduct.Stockno,
				stockName: updatedProduct.StockName,
				brand: updatedProduct.Brand == null ? "" : updatedProduct.Brand,
				groupCode: updatedProduct.GroupCode,
				specCode1: updatedProduct.SpecCode1,
				specCode2: updatedProduct.SpecCode2,
				specCode3: updatedProduct.SpecCode3,
				specCode4: updatedProduct.SpecCode4,
				specCode5: updatedProduct.SpecCode5,
				specCode6: updatedProduct.SpecCode6,
				specCode7: updatedProduct.SpecCode7,
				specCode8: updatedProduct.SpecCode8,
				specCode9: updatedProduct.SpecCode9,
				specCode10: updatedProduct.SpecCode10,
				status: typeof updatedProduct.Status == "undefined" ? 1 : updatedProduct.Status,
				note: updatedProduct.Note,
				cancelDate: updatedProduct.CancelDate == "" ? null : updatedProduct.CancelDate,
				description: updatedProduct.Description,
				debit: parseFloat(
					updatedProduct.Debit == "" || updatedProduct.Debit == null
						? 0
						: updatedProduct.Debit
				),
				credit: parseFloat(
					updatedProduct.Credit == "" || updatedProduct.Credit == null
						? 0
						: updatedProduct.Credit
				),
				remTotal: parseFloat(
					updatedProduct.RemTotal == "" || updatedProduct.RemTotal == null
						? 0
						: updatedProduct.RemTotal
				),
				remType: parseFloat(
					updatedProduct.RemType == "" || updatedProduct.RemType == null
						? 0
						: updatedProduct.RemType
				),
				currCode: updatedProduct.CurrCode,
				currDebit: parseFloat(
					updatedProduct.CurrDebit == "" || updatedProduct.CurrDebit == null
						? 0
						: updatedProduct.CurrDebit
				),
				currCredit: parseFloat(
					updatedProduct.CurrCredit == "" || updatedProduct.CurrCredit == null
						? 0
						: updatedProduct.CurrCredit
				),
				currRemTotal: parseFloat(
					updatedProduct.CurrRemTotal == "" || updatedProduct.CurrRemTotal == null
						? 0
						: updatedProduct.CurrRemTotal
				),
				currRemType: parseFloat(
					updatedProduct.CurrRemType == "" || updatedProduct.CurrRemType == null
						? 0
						: updatedProduct.CurrRemType
				),
				qEntery: parseFloat(
					updatedProduct.QEntery == "" || updatedProduct.QEntery == null
						? 0
						: updatedProduct.QEntery
				),
				qExit: parseFloat(
					updatedProduct.QExit == "" || updatedProduct.QExit == null
						? 0
						: updatedProduct.qExit
				),
				qRem: parseFloat(
					updatedProduct.QRem == "" || updatedProduct.QRem == null
						? 0
						: updatedProduct.QRem
				),
				qRem2: parseFloat(
					updatedProduct.QRem2 == "" || updatedProduct.QRem2 == null
						? 0
						: updatedProduct.QRem2
				),
				qRem3: parseFloat(
					updatedProduct.QRem3 == "" || updatedProduct.QRem3 == null
						? 0
						: updatedProduct.QRem3
				),
				qReserve: parseFloat(
					updatedProduct.QReserve == "" || updatedProduct.QReserve == null
						? 0
						: updatedProduct.QReserve
				),
				qReserve2: parseFloat(
					updatedProduct.QReserve2 == "" || updatedProduct.QReserve2 == null
						? 0
						: updatedProduct.QReserve2
				),
				qReserve3: parseFloat(
					updatedProduct.QReserve3 == "" || updatedProduct.QReserve3 == null
						? 0
						: updatedProduct.QReserve3
				),
				qDepot: parseFloat(
					updatedProduct.QDepot == "" || updatedProduct.QDepot == null
						? 0
						: updatedProduct.QDepot
				),
				stockName2: updatedProduct.StockName2,
				unitId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				vatSales: parseFloat(
					updatedProduct.VatSales == "" || updatedProduct.VatSales == null
						? 0
						: updatedProduct.VatSales
				),
				vatPurChase: parseFloat(
					updatedProduct.VatPurChase == "" || updatedProduct.VatPurChase == null
						? 0
						: updatedProduct.VatPurChase
				),
				quantityMin: parseFloat(
					updatedProduct.QuantityMin == "" || updatedProduct.QuantityMin == null
						? 0
						: updatedProduct.QuantityMin
				),
				quantityMax: parseFloat(
					updatedProduct.QuantityMax == "" || updatedProduct.QuantityMax == null
						? 0
						: updatedProduct.QuantityMax
				),
				minOrderQuantity: parseFloat(
					updatedProduct.MinOrderQuantity == "" || updatedProduct.MinOrderQuantity == null
						? 0
						: updatedProduct.MinOrderQuantity
				),
				taxPrivate: parseFloat(
					updatedProduct.TaxPrivate == "" || updatedProduct.TaxPrivate == null
						? 0
						: updatedProduct.TaxPrivate
				),
				taxPrivateTotal: parseFloat(
					updatedProduct.TaxPrivateTotal == "" || updatedProduct.TaxPrivateTotal == null
						? 0
						: updatedProduct.TaxPrivateTotal
				),
				ordersLevel: parseFloat(
					updatedProduct.OrdersLevel == "" || updatedProduct.OrdersLevel == null
						? 0
						: updatedProduct.OrdersLevel
				),
				actSupplierId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				packageQuantity: parseFloat(
					updatedProduct.PackageQuantity == "" || updatedProduct.PackageQuantity == null
						? 0
						: updatedProduct.PackageQuantity
				),
				customerStockNo: updatedProduct.CustomerStockNo,
				msg: updatedProduct.Msg,
				minReqQuantity: parseFloat(
					updatedProduct.MinReqQuantity == "" || updatedProduct.MinReqQuantity == null
						? 0
						: updatedProduct.MinReqQuantity
				),
				transCode: updatedProduct.TransCode,
				origin: updatedProduct.Origin,
				qtyTree: parseFloat(
					updatedProduct.QtyTree == "" || updatedProduct.QtyTree == null
						? 0
						: updatedProduct.QtyTree
				),
				depotId: updatedProduct.DepotId,
				depotName: updatedProduct.DepotName,
				barcode: updatedProduct.Barcode,
				CompanyId: updatedProduct.CompanyId,
				CompanyInfoId: "",
				CompanyInfoName: "",
				CompanyName: updatedProduct.CompanyName,
			};
			console.log(obj);
			this.$store
				.dispatch("stock/updateStock", obj)
				.then((response) => {
					if (response.status == 200) {
						setTimeout(() => {
							vs.loading.close("#loading-stock-list > .con-vs-loading");
						}, 1000);
						try {
							const nextRowIndex = event.rowIndex + 1;
							const colKey = event.column.getColId();

							if (nextRowIndex < event.api.getDisplayedRowCount()) {
								this.gridApi.startEditingCell({
									rowIndex: nextRowIndex,
									colKey: colKey,
								});
							} else {
								this.gridApi.stopEditing();
							}
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							setTimeout(() => {
								vs.loading.close("#loading-pull-stock> .con-vs-loading");
							}, 1000);
						} catch (error) {
							setTimeout(() => {
								vs.loading.close("#loading-pull-stock> .con-vs-loading");
							}, 1000);
							console.log(error);
						}
					} else
						setTimeout(() => {
							vs.loading.close("#loading-stock-list > .con-vs-loading");
						}, 1000);
				})
				.catch((error) => {
					setTimeout(() => {
						vs.loading.close("#loading-stock-list > .con-vs-loading");
					}, 1000);
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		matchStockList() {
			this.$router
				.push({
					name: "match-stock",
				})
				.catch(() => { });
		},
		listStock() {
			let type = "material";
			var vs = this.$vs;
			vs.loading({
				container: `#loading-stock-list`,
				type,
				scale: 0.5,
			});
			this.$store
				.dispatch("stock/listStockForRole")
				.then((response) => {
					setTimeout(() => {
						vs.loading.close("#loading-stock-list > .con-vs-loading");
					}, 1000);
					if (response)
						if (response.success == true) {
						} else console.log(response);
				})
				.catch((error) => {
					console.log(error);
					setTimeout(() => {
						vs.loading.close("#loading-stock-list > .con-vs-loading");
					}, 1000);
				});
		},
		addWithExcel() {
			this.toggleDataSidebarWithExcel(true);
		},
		getCustomerDepoList() {
			const vs = this.$vs;
			this.storehouse_choices = [];
			if (userJson.type == "fullfilment")
				this.$store
					.dispatch("storehouse/listStorehouseAllValues2", this.customer.CompanyId)
					.then((response) => {
						// let costumerList = JSON.parse(response.json);
						if (response.success == true) {
							this.storehouseForCustomerList = JSON.parse(response.json);
							this.storehouseForCustomerList.forEach((val, index) => {
								this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
							});
						} else console.log(response.statusText);
						/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
					});
			else {
				let depotMethods = "listStorehouseForCompany"

				if (userJson.type == "dropshipping") depotMethods = "listStorehouseAllValues2Ds"
				this.$store
					.dispatch("storehouse/" + depotMethods, this.customer.CompanyId)
					.then((response) => {
						// let costumerList = JSON.parse(response.json);
						if (response.success == true) {
							this.storehouseForCustomerList = JSON.parse(response.json);
							this.storehouseForCustomerList.forEach((val, index) => {
								this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
							});
						} else console.log(response.statusText);
						/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
					});
			}
		},
		mpControl(e) {
			if (
				!e.includes("Toplu") &&
				!e.includes("Flip") &&
				!e.includes("Php") &&
				!e.includes("Tümü")
			)
				return true;
			else return false;
		},
		errorImage(e) {
			if (e.type == "error")
				e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
		},
		getCustomerMarketplaces() {
			const vs = this.$vs;
			this.timelineData = [];
			this.$store
				.dispatch("customer/listCustomerinfoForRole", this.customer.CompanyId)
				.then((response) => {
					// let costumerList = JSON.parse(response.json);
					if (response.success == true) {
						this.marketplace_choices = JSON.parse(response.json);
					} else console.log(response.statusText);
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
		},
		clearFields() {
			this.$root.$emit("closePalletItemsPopup2", false);
		},
		pullStock() {
			let type = "material";
			var vs = this.$vs;
			if (this.marketplace == "" || this.customer == "" || this.storehouse == "") {
				vs.notify({
					text: this.$t("Validate"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "success",
					position: "top-center",
				});
			} else {
				vs.loading({
					container: `#loading-pull-stock`,
					type,
					scale: 0.75,
				});
				let obj = {
					companyInfoId: this.marketplace.CompanyInfoId,
					depotId: this.storehouse.value,
				};
				this.$store
					.dispatch("stock/pullStock", obj)
					.then((response) => {
						if (response.success == true) {
							let parsedStock = JSON.parse(response.json);
							parsedStock.forEach((val, index) => {
								parsedStock[index].DepotName = this.storehouse.name;
							});

							this.$store
								.dispatch("stock/addStockList", parsedStock)
								.then((response) => {
									if (response.data.status == 200) {
										try {
											this.getStockList();
											vs.notify({
												text: response.message,
												iconPack: "feather",
												icon: "icon-alert-circle",
												color: "success",
												position: "top-center",
											});
											setTimeout(() => {
												vs.loading.close("#loading-pull-stock> .con-vs-loading");
											}, 1000);
											vs.notify({
												text: response.data.message,
												iconPack: "feather",
												icon: "icon-alert-circle",
												color: "success",
												position: "top-center",
											});
										} catch (error) {
											setTimeout(() => {
												vs.loading.close("#loading-pull-stock> .con-vs-loading");
											}, 1000);
											console.log(error);
										}
									} else
										setTimeout(() => {
											vs.loading.close("#loading-pull-stock> .con-vs-loading");
										}, 1000);
									console.log(error);
									vs.notify({
										text: response.data.message.toString(),
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "danger",
										position: "top-center",
									});
								})
								.catch((error) => {
									console.log(error);
									return new Promise((resolve, reject) => {
										resolve(false);
									});
								});
						} else {
							setTimeout(() => {
								vs.loading.close("#loading-pull-stock> .con-vs-loading");
							}, 1000);
							vs.notify({
								text: response.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					})
					.catch((error) => {
						console.log(error);
						setTimeout(() => {
							vs.loading.close("#loading-pull-stock> .con-vs-loading");
						}, 1000);
						return new Promise((resolve, reject) => {
							resolve(false);
						});
					});
			}
		},
		pullStockList() {
			this.bulkStockPopup = true;
		},
		deleteSubmitAll() {
			var selectedRows = this.gridApi.getSelectedRows();
			selectedRows.forEach((val, index) => {
				this.deleteSubmit(val);
			});
		},

		filterStockList() {
			const vs = this.$vs;
			if (this.searchedVal != "") {
				let obj = {
					depotId: this.storehouseForFilter.value,
					param: this.searchedVal,
				};
				this.$store
					.dispatch("stock/listStockForFilter", obj)
					.then((response) => {
						if (response.status == 200) {
							try {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center",
								});
							} catch (error) {
								console.log(error);
							}
						} else
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
					})
					.catch((error) => {
						console.log(error);
						return new Promise((resolve, reject) => {
							resolve(false);
						});
					});
			} else {
				this.getStockList();
			}
			/*  this.stockList = this.stockListFiltered;
			this.stockList = this.stockList.filter((post) => {
				return (
					post.StockName.toUpperCase().includes(this.searchedVal.toUpperCase()) ||
					post.Stockno.toUpperCase().includes(this.searchedVal.toUpperCase())
				);
			});*/
		},
		addBarcodePopup(data) {
			this.barcodeData = data;
			this.isBarcodeAddActive = true;
		},
		toggleDataSidebarBarcode(val = false) {
			this.isBarcodeAddActive = val;
		},
		deleteSubmit(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("stock/deleteStock", data.StockId)
				.then((response) => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.getStockList();
							this.deleteWarningPromptValid = false;
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		deleteStock() {
			this.deleteWarningPromptValid = true;
		},
		closeDeleteWarning() {
			this.deleteWarningPromptValid = false;
		},
		updateCustomer(data) {
			this.sidebarData = data;
			this.toggleDataSidebar(true);
		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY HH:mm");
		},
		getStockList() {
			const vs = this.$vs;
			this.stockList = [];
			this.stockColumns = [];
			this.stockList = JSON.parse(JSON.stringify(this.stock));
			this.stockListFiltered = JSON.parse(JSON.stringify(this.stock));
			let type = "material";
			vs.loading({
				container: `#loading-stock-list`,
				type,
				scale: 0.5,
			});
			if (this.stockList.length > 0) {
				setTimeout(() => {
					vs.loading.close("#loading-stock-list > .con-vs-loading");
				}, 1000);
				let columnList = Object.keys(this.stockList[0]);
				this.stockColumns.push({
					headerCheckboxSelection: true,
					checkboxSelection: true,
					showDisabledCheckboxes: true,

					width: 20,
					pinned: "left",
				});
				this.stockColumns.push({
					width: 100,
					pinned: "left",
					cellRendererFramework: "updateDeleteBtnCellRenderer",
				});
				columnList.forEach((val, index) => {
					if (
						val == "Stockno" ||
						val == "CompanyName" ||
						val == "StockName" ||
						val == "QuantityMin"
					) {
						if (this.isMobile())
							this.stockColumns.push({
								width: 150,
								headerName: this.$t(val),
								field: val,
								filter: "agSetColumnFilter",
								cellRendererFramework: "TextViewCellRenderer",
							});
						else
							this.stockColumns.push({
								width: 150,
								headerName: this.$t(val),
								pinned: "left",
								field: val,
								filter: "agSetColumnFilter",
								cellRendererFramework: "TextViewCellRenderer",
							});
					} else if (val == "Status")
						this.stockColumns.push({
							width: 80,
							headerName: this.$t(val),
							cellRendererFramework: "statusShowCellRenderer",
							field: val,
							filter: "agSetColumnFilter",
						});
					else if (val.toString().includes("Date") == true) {
						this.stockColumns.push({
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
							valueFormatter: (params) => this.parseDate(params.data[val]),
						});
					} else if (
						val != "ActSupplierId" &&
						val != "DepotId" &&
						val != "CompanyInfoId" &&
						val != "CompanyId" &&
						val != "StockId" &&
						val != "UnitId" &&
						val.toString().includes("Date") == false
					) {
						this.stockColumns.push({
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
							cellRendererFramework: "TextViewCellRenderer",
						});
					}
				});
			} else {
				setTimeout(() => {
					vs.loading.close("#loading-stock-list > .con-vs-loading");
				}, 1000);
			}
		},
		toggleDataSidebarWithExcel(val = false) {
			this.addWithExcelPopup = val;
		},

		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},

		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},

		sendMessageToIframe() {
			console.log(this.marketplace)
			if (this.iframe && this.iframe.contentWindow && this.marketplace.CompanyInfoId) {

				this.iframe.contentWindow.postMessage(
					{
						token: this.$store.state.AppActiveUser.fullFilmentTokenId,
						service: this.$store.state.AppActiveUser.servisAdresi,
						account: "fullfilment",
						marketplace: this.marketplace.CompanyInfoId,
						marketplaceName: this.marketplace.Name
					},
					this.iframeSrc
				);
			}
		}
	},
	mounted() {
		this.iframe = document.getElementById("myIframe");
		if (this.iframe) {
			this.iframe.addEventListener("load", () => {
				this.sendMessageToIframe();
			});
		}
		this.getStockList();
		this.getCustomerDepoList();

		if (this.ROLE == "Company") {
			this.getCustomerMarketplaces();
			this.customer = { value: this.$store.state.AppActiveUser.companyid };
		}
		//tables global olarak tanımlanıyor
		this.$root.$on("addNewData", () => {
			this.addNewData();
		});
		this.$root.$on("deleteDataBtn", (data) => {
			this.deleteData = data;
			this.deleteStock(data);
		});
		this.$root.$on("getStockList", () => {
			this.getStockList();
		});
		this.$root.$on("editDataBtn", (data) => {
			this.updateCustomer(data);
		});
		this.$root.$on("closeDeleteWarning", () => {
			this.closeDeleteWarning();
		});
		this.$root.$on("deleteSubmit", (data) => {
			if (this.wholeStockActions == true) this.deleteSubmitAll();
			else this.deleteSubmit(data);
		});
		this.$root.$on("closeBarcodePopup", () => {
			this.toggleDataSidebarBarcode(false);
		});
		this.$root.$on("addBarcodePopup", (data) => {
			this.addBarcodePopup(data);
		});
	},
	beforeDestroy() {
		this.$root.$off("deleteDataBtn");
		this.$root.$off("addNewData");
		this.$root.$off("getStockList");
		this.$root.$off("editDataBtn");
		this.$root.$off("closeDeleteWarning");
		this.$root.$off("deleteSubmit");
		this.$root.$off("addBarcodePopup");
		this.$root.$off("closeBarcodePopup");
	},
	watch: {
		company(val) {
			this.customer_choices = val;
			return val;
		},
		stock(val) {
			this.getStockList();

			return val;
		},

	},
	created() {
		this.customer_choices = this.company;
		this.rowClassRules = {
			// row style function
			"bg-danger-item-ag": (params) => {
				var difference =
					parseFloat(params.data.QEntery == null ? 0 : params.data.QEntery) -
					parseFloat(params.data.QExit == null ? 0 : params.data.QExit);
				var quantityMin = parseFloat(
					params.data.QuantityMin == null || params.data.QuantityMin == ""
						? 0
						: params.data.QuantityMin
				);
				return difference <= quantityMin && difference != 0;
			},
			"bg-success-item-ag": (params) => {
				var difference = params.data.isCreate;
				return difference == "success";
			},
		};
	},
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 130px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

[dir] .btn-group button {
	padding: 4px !important;
}

.bg-success-item-ag {
	background-color: #f4f9c4 !important;
}

.bg-danger-item-ag {
	background-color: #f8cbcc !important;
}
</style>
